import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {

};

export type _I18nBookingSlider = typeof _fr;

const _en: _I18nBookingSlider = {

};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nBookingSlider(lang?: string): _I18nBookingSlider {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}